export default __webpack_public_path__ + "static/media/solution_60.9acaf252.svg";